import CorporateNavigation from '@common/Components/CorporateNavigation.vue';
import { ICommandStatus } from '@cqrs/cqrs';
import { ICommandBase } from '@Quest/cqrs';
import { DeleteMetricCommandV1 } from '@Quest/Metrics/Domain/commands-core';
import MetricsCommands from "@Quest/Metrics/Domain/commands-vue-component";
import MetricsQueries from "@Quest/Metrics/Domain/queries-vue-component";
import { MetricReadModel, MetricsPageReadModel } from '@Quest/Metrics/Domain/readmodels';
import Component, { mixins } from 'vue-class-component';


@Component({ components: { CorporateNavigation } })
export default class MetricsPage extends mixins(MetricsQueries, MetricsCommands)
{
    get workspaceId(): number { return Number.parseInt(this.$route.params.workspaceId); }
    get strategyId() { return this.$route.params.strategyId; }

    rm: MetricsPageReadModel | null = null;
    searchPhrase: string | null = null;
    filterByMetricType: string | null = null;

    get metricsView(): MetricReadModel[]
    {
        if (!this.rm || !this.rm.Metrics) return [];

        const phrase = this.searchPhrase?.toLowerCase();
        const typeFilter = this.filterByMetricType;

        return this.rm.Metrics.filter(a =>
            (!phrase || a.Name.toLowerCase().includes(phrase)) &&
            (!typeFilter || a.MetricTypeLabel === typeFilter)
        );
    }

    setFilterByMetricType(metricType: string | null)
    {
        this.filterByMetricType = metricType;
    }


    getEditUrl(m: MetricReadModel): string
    {
        switch (m.MetricType)
        {
            case 'CostSubtotalMetric':
                return `/#/enterprise/edit-cost-subtotal-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'ResourceMetric':
                return `/#/enterprise/edit-resource-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'ResourceCostMetric':
                return `/#/enterprise/edit-resource-cost-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'RevenueMetric':
                return `/#/enterprise/edit-revenue-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'MarginCogsMetric':
                return `/#/enterprise/edit-margin-cogs-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'TotalCostMetric':
                return `/#/enterprise/edit-total-cost-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'CapexMetric':
                return `/#/enterprise/edit-capex-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'ExpenseMetric':
                return `/#/enterprise/edit-expense-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            default:
                return '';
        }
    }

    getCloneUrl(m: MetricReadModel): string
    {
        switch (m.MetricType)
        {
            case 'CostSubtotalMetric':
                return `/#/enterprise/clone-cost-subtotal-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'ResourceMetric':
                return `/#/enterprise/clone-resource-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'ResourceCostMetric':
                return `/#/enterprise/clone-resource-cost-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'RevenueMetric':
                return `/#/enterprise/clone-revenue-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'MarginCogsMetric':
                return `/#/enterprise/clone-margin-cogs-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'TotalCostMetric':
                return `/#/enterprise/clone-total-cost-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'CapexMetric':
                return `/#/enterprise/clone-capex-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            case 'ExpenseMetric':
                return `/#/enterprise/clone-expense-metric/${this.workspaceId}/${this.strategyId}/${m.Id}`;
            default:
                return '';
        }
    }


    handleDeleteMetricCommand(id: string)
    {
        if (confirm("Are you sure?") === true)
        {
            this.invokeDeleteMetricCommandV1(this.workspaceId, this.strategyId, id);
        }
    }


    mounted()
    {
        document.title = "Metrics | TransparentChoice";
        this.runMetricsPageQueryV1(this.workspaceId, this.strategyId);
    }

    onSetModel(model: any, modelName: string) 
    {
        if (modelName === "MetricsPageReadModel")
        {
            this.rm = model as MetricsPageReadModel;
        }
    }

    onCommandSucceed(cmd: ICommandBase, correlationId: string)
    {
        if (DeleteMetricCommandV1.matchType(cmd))
        {
            this.runMetricsPageQueryV1(this.workspaceId, this.strategyId);
        }
    }

    onCommandFailed(status: ICommandStatus)
    {
        if (DeleteMetricCommandV1.matchType(status.Command))
        {
            const error = status.ValidationErrors[0];
            alert(error.Error);
        }
    }
}